import { useFormContext, useWatch } from 'react-hook-form';

import { ObjectPaths } from 'utils/objectPaths';

import { buildFieldPathInForm } from './formEnvironment';

export function useFormWatch<T = string, TForm = Record<string, any>>(
  path: ObjectPaths<TForm>
): T {
  const { control, getValues } = useFormContext();

  return (
    useWatch({
      name: path,
      control,
    }) ?? getValues(path)
  );
}

export function useSubFormWatch<
  T = string,
  TSubForm = Record<string, any>,
  TForm = Record<string, any>,
>(path: ObjectPaths<TSubForm>, formPath?: ObjectPaths<TForm>): T {
  const { control, getValues } = useFormContext();

  const fullPath = buildFieldPathInForm<TForm, TSubForm>(path, formPath);

  return useWatch({ name: fullPath, control }) ?? getValues(fullPath);
}
